import { makeContactRequestFire } from './contact-request'

import { getUserConversations } from '../../Conversations/middleware/conversation-fire'

const addContactMiddelware = store => next => action => {

  switch (action.type) {

    default:
      return next(action)
  }

}

export default addContactMiddelware;


// WEBPACK FOOTER //
// ./src/Components/AddContactPage/middleware/index.js